import React from 'react'
import { format } from 'date-fns'

import AttachmentPreview from './AttachmentPreview'

// Render a single message in a ticket thread. Internal comments are visually
// distinguished from public replies via a colored border/background and an
// "Internal" badge (Req 5.4). Dates render via date-fns, handling both a
// Firestore Timestamp (has .toDate()) and a plain JS Date.
const MessageItem = ({ message }) => {
  if (!message) return null

  const { authorEmail, internal, body, attachments = [], createdAt } = message

  const date = createdAt?.toDate ? createdAt.toDate() : createdAt
  const isValidDate = date instanceof Date && !isNaN(date)
  const formattedDate = isValidDate ? format(date, 'PPpp') : ''

  const containerClass = internal
    ? 'p-3 m-2 rounded border-l-4 bg-yellow-50 border-yellow-400'
    : 'p-3 m-2 rounded border-l-4 bg-white border-gray-200'

  return (
    <div className={containerClass}>
      <div className='flex items-center justify-between gap-2'>
        <div className='flex items-center gap-2'>
          <span className='font-semibold text-gray-800'>{authorEmail}</span>
          {internal && (
            <span className='px-2 py-0.5 rounded text-xs font-semibold bg-yellow-400 text-yellow-900'>
              Internal
            </span>
          )}
        </div>
        {formattedDate && (
          <span className='text-xs text-gray-500'>{formattedDate}</span>
        )}
      </div>

      <p className='mt-2 whitespace-pre-wrap text-left text-gray-700'>{body}</p>

      {attachments.length > 0 && (
        <div className='mt-2 flex flex-wrap gap-2'>
          {attachments.map((attachment, index) => (
            <AttachmentPreview key={attachment.storagePath || index} attachment={attachment} />
          ))}
        </div>
      )}
    </div>
  )
}

export default MessageItem
